import { Log } from 'ng2-logger';
import ApiClient from './alms-api';
import Translator from '../core/i18n';
import { IPayloadIFrame } from '../models/components/iframe';

const _logger = Log.create('IFrame-Service');
const T = Translator.create();
const token: any = localStorage.getItem('access_token');
let _apiClient: ApiClient;

export class IFrameService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetIFrameSourceAsync(params: any) {
        const parsedUrl = new URL(window.location.href);
        return _apiClient.RequestAsync('POST', 'api/account/connectWebToAlmsWithIframe', {
            Host: parsedUrl.hostname,
            Port: parsedUrl.port,
            Scheme: parsedUrl.protocol,
            ActivityId: params.ActivityId,
            ClassId: params.ClassId,
            CourseId: params.CourseId,
            UserId: params.UserId,
            EnrollmentId: params.EnrollmentId,
            ReportFileName: params.ReportFileName,
            ReturnUrl: params.ReturnUrl
        }, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }
}

